import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { messages } from "../../../data";
import CheckIcon from "@mui/icons-material/Check";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import DonationDrawer from "../../Donations/DonationDrawer";
import { ComponentType } from "../../../common/enum";
import {
  query,
  orderBy,
  limit,
  onSnapshot,
  collection as firebaseCollection,
  collectionGroup,
  where,
  getDocs,
} from "firebase/firestore";

import { DEFAULT_AVATAR_URL } from "../../../common/enum";
import { db } from "../../../firebase";
import { ListItemButton } from "@mui/material";
import ChatPanel from "../../MessagePanel/ChatPanel";
import { fetchAllNotifications } from "../slice";
import { useDispatch, useSelector } from "react-redux";
import { getDonationById , getDonationEntityDetailById} from "../../MessagePanel/slice";
export default function NotificationListDashboard({ t }) {
  const {
    auth: { profile },
    dashboardInfo: { myActiveDonationsOffSet, myActiveDonationsLimit, entityProfileSelect },
  } = useSelector((state) => state);
  const [entitiesNotifications, setEntitiesNotifications] = React.useState([]);
  const [selectedIndex, setSelectedIndex] = React.useState();
  const [drawerState, setDrawerState] = React.useState(false);
  const [donationDetail, setdonationDetail] = React.useState(null);

  const dispatch = useDispatch();

  const toggleDrawer = React.useCallback((value) => {
    setDrawerState(value);
  }, []);

  
  // const handleListItemClick2 = React.useCallback((value) => {
  //   var itemteste = all.filter(product => product.donation.id === value.id2)
  //   setItemValue(itemteste)
  //   setDrawerState(true);
  // }, []);

  const handleListItemClick = React.useCallback((value) => {
    var donationDetail = [];
    let payload = {};
    payload["donationId"] = value;
    if (Object.keys(payload).length > 0) {
      dispatch(getDonationById(payload))
        .unwrap()
        .then((res) => {
          setdonationDetail(res.donationId.donations)
            setDrawerState(true);
         
          
        })
        .catch((err) => {
           console.log(err);
        });
    }
  }, [dispatch]);



  React.useEffect(() => {
    if(profile.entity.entityType == 'DONOR' || entityProfileSelect == 'DONOR'){
      getNotificationsServer();
    }
  }, []);


  const getNotificationsServer = () => {
    var entityId = profile?.userId;
    dispatch(fetchAllNotifications(entityId))
    .unwrap()
    .then((res) => {
      var doacoesexpiradas = res.data.notifications.filter(w=> w.entitySenderDetails.title == 'Fim de doação')
      setEntitiesNotifications(doacoesexpiradas);
    })
    .catch((error) => {
      //console.log(error);
    });

  };


  return (
    <>
      <List sx={{ width: "100%", bgcolor: "background.paper" ,maxHeight: "247px" , overflowY: 'auto'}}>
      {entitiesNotifications.length > 0 &&
        entitiesNotifications?.map((message, index) => (
            <React.Fragment key={index}>
              <ListItemButton
                sx={{ pl: 1, pr: 0 }}
                selected={selectedIndex === index}
                onClick={(event) =>
                  handleListItemClick(message?.entitySenderDetails?.idDonation)
                }
              >
                <ListItem alignItems="flex-start" sx={{ pl: 0, pr: 0 ,display: "flex" , flexDirection: "row" , flexWrap : "nowrap" , alignItems: "center"}} >
                  
                  <ListItemText 
                      primary={
                        <Typography >
                          {message?.entitySenderDetails?.title}<br></br>{
                            " #"+ message?.entitySenderDetails?.codDoacao
                          }
                        </Typography>
                      }
                      secondary={
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary"
                        >
                          {message?.entitySenderDetails?.note}
                        </Typography>
                      }
                    />
                    <Typography sx={{fontWeight: "400",color: "#637381" , fontSize:"11px"}}>
                      {`${new Date(
                        message.entitySenderDetails.updatedDate
                      ).toLocaleTimeString("pt", {
                        hour: "numeric",
                        minute: "numeric",
                      })}m`}
                    </Typography>
                  <Chip
                    label={message?.entitySenderDetails?.isRead ? t("read") : t("unRead")}
                    icon={
                      message?.entitySenderDetails?.isRead ? (
                        <CheckIcon
                          sx={{ color: "#1B727E", fontSize: "small"}}
                        />
                      ) : (
                        <FiberManualRecordIcon
                          sx={{ color: "pink", fontSize: "small" }}
                        />
                      )
                    }
                    sx={{
                      backgroundColor: message?.entitySenderDetails?.isRead ? "#E4F2E8" : "#ffcbcb82",
                      // color: message.isRead ? "#1B727E" : "red",
                      width: "fit-content",
                      justifyContent:"left",
                      mx: 1,
                      "& .MuiChip-label": {
                        fontWeight: 600,
                        fontFamily: "Poppins",
                      },
                      "& .MuiChip-icon": {
                        color: message?.entitySenderDetails?.isRead ? "#1B727E" : "red",
                      },
                    }}
                  />
                </ListItem>
              </ListItemButton>
              <Divider variant="outset" component="li" />
            </React.Fragment>
          ))}
        
        {entitiesNotifications.length === 0 && (
          <Typography
            sx={{ display: "inline" }}
            variant="body2"
            color="text.primary"
            textAlign="center"
          >
            {"Não há notificações de momento."}
          </Typography>
        )}
      </List>
      {donationDetail && <DonationDrawer
        drawerState={drawerState}
        toggleDrawer={toggleDrawer}
        donationDetail={donationDetail}
        donationStatus={"EXPIRED"}
        // donationFilter={donationFilter}
        component={ComponentType.DONATION}
        t={t}
      />}
    </>
  );
}
